/* Gentle Beauty — AJAX filtering / sorting / pagination engine.
   Used by sections/gb-main-collection.liquid and sections/gb-main-search.liquid.
   Root: [data-gb-facets][data-section-id]. Refreshable regions: [data-gb-facets-part="key"].
   Other sections can stay in sync by including [data-gb-facets-sync="SECTION_ID"] (e.g. gb-quick-filter).
   Public: document event `gb:facets:update` { url } → refresh grid without reload. Emits `gb:facets:updated`. */
(function () {
  'use strict';
  if (window.GBFacets) return;

  var DESKTOP = window.matchMedia('(min-width: 990px)');
  var instances = [];

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function debounce(fn, wait) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); }; }
  function store(key, val) {
    if (window.GB && GB.store) { if (val === undefined) return GB.store.get(key, null); GB.store.set(key, val); return; }
    try { if (val === undefined) return JSON.parse(localStorage.getItem(key)); localStorage.setItem(key, JSON.stringify(val)); } catch (e) { return null; }
  }
  function money(cents) {
    if (window.GB && GB.formatMoney) return GB.formatMoney(cents);
    return (cents / 100).toFixed(2);
  }
  function cleanParams(input) {
    var p = new URLSearchParams(input);
    ['section_id', 'sections', 'view'].forEach(function (k) { p.delete(k); });
    var out = new URLSearchParams();
    p.forEach(function (v, k) { if (v !== '') out.append(k, v); });
    return out;
  }
  function paramsFromUrl(url) {
    var u = new URL(url, window.location.origin);
    return cleanParams(u.search).toString();
  }
  var cache = new Map();

  function Facets(root) {
    this.root = root;
    this.sectionId = root.getAttribute('data-section-id');
    this.layout = root.getAttribute('data-layout') || 'sidebar';
    this.paginationType = root.getAttribute('data-pagination') || 'numbered';
    this.scrollToTop = root.getAttribute('data-scroll') !== 'false';
    this.applyMode = root.getAttribute('data-apply') || 'live';
    this.alignMode = root.getAttribute('data-align') === 'true';
    this.openState = {};
    this.moreState = {};
    this.loading = false;
    this.initialSearch = window.location.search;
    this.init();
  }

  Facets.prototype.init = function () {
    var self = this, root = this.root;
    this.panel = $('[data-gb-facets-panel]', root);
    this.captureStates(true);
    this.syncMode();
    this.applyDensity();
    this.bindPrice();
    this.observeInfinite();
    this.initSticky();
    this.initAlign();

    this.onModeChange = function () { self.syncMode(); };
    if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', this.onModeChange); else DESKTOP.addListener(this.onModeChange);

    this.debouncedSubmit = debounce(function () { self.submit(); }, 180);
    this.debouncedPriceSubmit = debounce(function () { self.submit(); }, 650);

    root.addEventListener('click', function (e) { self.onClick(e); });
    root.addEventListener('change', function (e) { self.onChange(e); });
    root.addEventListener('input', function (e) { self.onInput(e); });
    root.addEventListener('submit', function (e) {
      if (!e.target.matches('[data-gb-facets-form]')) return;
      e.preventDefault();
      self.root.classList.remove('is-dirty');
      self.submit();
      if (self.isDrawer() && self.panel && window.GB) GB.closeDrawer(self.panel);
    });
    root.addEventListener('keydown', function (e) { self.onKeydown(e); });

    this.onDocClick = function (e) {
      if (self.layout === 'horizontal' && DESKTOP.matches && !e.target.closest('[data-gb-facet]')) self.closeDropdowns();
      if (!e.target.closest('[data-gb-sort]')) self.closeSort();
    };
    document.addEventListener('click', this.onDocClick);

    document.addEventListener('gb:drawer:close', function (e) {
      if (self.panel && e.detail && e.detail.id === self.panel.id) {
        $$('[data-gb-facets-open]', root).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      }
    });
  };

  /* ---------- Drawer vs static presentation ---------- */
  Facets.prototype.isDrawer = function () {
    return this.layout === 'drawer' || !DESKTOP.matches;
  };
  Facets.prototype.syncMode = function () {
    var p = this.panel; if (!p) return;
    if (this.isDrawer()) {
      p.setAttribute('role', 'dialog');
      p.setAttribute('aria-modal', 'true');
      if (!p.classList.contains('is-open')) p.setAttribute('aria-hidden', 'true');
    } else {
      if (p.classList.contains('is-open') && window.GB) GB.closeDrawer(p);
      p.removeAttribute('role'); p.removeAttribute('aria-modal'); p.removeAttribute('aria-hidden');
    }
    this.root.classList.toggle('is-drawer-mode', this.isDrawer());
  };

  /* ---------- Events ---------- */
  Facets.prototype.onClick = function (e) {
    var t = e.target, el;

    if ((el = t.closest('[data-gb-facets-hide]')) && !this.isDrawer()) {
      e.preventDefault();
      this.toggleSidebar(true);
      var opener = $('[data-gb-facets-open]', this.root); if (opener) opener.focus();
      return;
    }

    if ((el = t.closest('[data-gb-facets-open]'))) {
      e.preventDefault();
      if (this.isDrawer()) {
        if (window.GB) GB.openDrawer(this.panel, el);
        el.setAttribute('aria-expanded', 'true');
      } else if (this.layout === 'sidebar') {
        this.toggleSidebar(!this.root.classList.contains('is-filters-hidden'));
      }
      return;
    }

    if ((el = t.closest('[data-gb-facet-toggle]'))) {
      e.preventDefault();
      var group = el.closest('[data-gb-facet]');
      var open = el.getAttribute('aria-expanded') !== 'true';
      if (open && this.layout === 'horizontal' && DESKTOP.matches) this.closeDropdowns(group);
      this.setGroup(group, open);
      return;
    }

    if ((el = t.closest('[data-gb-facet-more]'))) {
      e.preventDefault();
      var g = el.closest('[data-gb-facet]');
      var expanded = el.getAttribute('aria-expanded') !== 'true';
      this.moreState[g.getAttribute('data-gb-facet')] = expanded;
      this.setMore(g, expanded);
      return;
    }

    if ((el = t.closest('[data-gb-sort-button]'))) {
      e.preventDefault();
      var list = $('[data-gb-sort-list]', el.parentNode);
      if (list.hidden) this.openSort(el, list); else this.closeSort();
      return;
    }

    if ((el = t.closest('[data-gb-sort-list] [role="option"]'))) {
      e.preventDefault();
      this.chooseSort(el);
      return;
    }

    if ((el = t.closest('[data-gb-view]'))) {
      e.preventDefault();
      store('gb:grid-view', el.getAttribute('data-gb-view'));
      this.applyDensity();
      return;
    }

    if ((el = t.closest('[data-gb-density]'))) {
      e.preventDefault();
      var kind = el.getAttribute('data-gb-density'), n = parseInt(el.getAttribute('data-cols'), 10);
      store('gb:grid-' + kind, n);
      this.applyDensity();
      return;
    }

    if ((el = t.closest('a[data-gb-facets-more]'))) {
      e.preventDefault();
      this.loadMore(el);
    }
  };

  Facets.prototype.onChange = function (e) {
    var t = e.target;
    if (!t.closest('[data-gb-facets-form]')) return;
    if (t.matches('[data-gb-facet-search]')) return;
    var live = this.applyMode !== 'button';
    if (!live) this.root.classList.add('is-dirty');
    if (t.matches('[data-gb-price-range]')) { this.syncPriceFromRange(t, true); if (live) this.debouncedPriceSubmit(); return; }
    if (t.matches('[data-gb-price-input]')) { this.syncPriceFromInput(t); if (live) this.debouncedPriceSubmit(); return; }
    if (t.type === 'checkbox' && live) this.debouncedSubmit();
  };

  Facets.prototype.toggleSidebar = function (hide) {
    this.root.classList.toggle('is-filters-hidden', hide);
    $$('[data-gb-facets-open]', this.root).forEach(function (b) {
      b.setAttribute('aria-expanded', hide ? 'false' : 'true');
      var lab = b.querySelector('.gb-toolbar__filter-label');
      if (lab) lab.textContent = hide ? lab.getAttribute('data-label-show') : lab.getAttribute('data-label-hide');
    });
    this.align();
  };

  /* ---------- Sidebar rising beside the sections above (desktop) ---------- */
  Facets.prototype.initAlign = function () {
    if (!this.alignMode) return;
    var self = this;
    this.onAlign = debounce(function () { self.align(); }, 100);
    window.addEventListener('resize', this.onAlign, { passive: true });
    window.addEventListener('load', this.onAlign);
    document.addEventListener('gb:facets:updated', this.onAlign);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.onAlign);
    this.align();
  };
  Facets.prototype.align = function () {
    if (!this.alignMode || !this.panel) return;
    var html = document.documentElement, panel = this.panel;
    var section = this.root.closest('.shopify-section');
    var targets = [], prev = section ? section.previousElementSibling : null;
    while (prev) {
      var t = prev.querySelector('[data-gb-align-sidebar]');
      if (t) { targets.unshift(t); prev = prev.previousElementSibling; continue; }
      if (prev.querySelector('[data-gb-facets-sync]') && !prev.querySelector('.gb-section')) { prev = prev.previousElementSibling; continue; }
      break;
    }
    var active = DESKTOP.matches && targets.length > 0 && !this.root.classList.contains('is-filters-hidden');
    html.classList.toggle('gb-sidebar-aligned', active);
    this.root.classList.toggle('is-aligned', active);
    panel.style.marginTop = '';
    if (!active) return;
    var layoutEl = panel.parentNode && panel.parentNode.classList.contains('gb-facets-layout') ? panel.parentNode : panel;
    var pull = layoutEl.getBoundingClientRect().top - targets[0].getBoundingClientRect().top;
    if (pull > 0) panel.style.marginTop = (-pull) + 'px';
  };

  Facets.prototype.onInput = function (e) {
    var t = e.target;
    if (t.matches('[data-gb-facet-search]')) { this.searchValues(t); return; }
    if (t.matches('[data-gb-price-range]')) { this.syncPriceFromRange(t, false); return; }
    if (t.matches('[data-gb-price-input]')) { this.syncPriceFromInput(t); if (this.applyMode !== 'button') this.debouncedPriceSubmit(); }
  };

  Facets.prototype.onKeydown = function (e) {
    var t = e.target;
    if (e.key === 'Enter' && t.matches('[data-gb-facet-search]')) { e.preventDefault(); return; }
    if (e.key === 'Escape') {
      if (this.layout === 'horizontal' && DESKTOP.matches && t.closest('[data-gb-facet]')) {
        var g = t.closest('[data-gb-facet]'); this.setGroup(g, false);
        var btn = $('[data-gb-facet-toggle]', g); btn && btn.focus();
      }
      var sortOpen = $('[data-gb-sort-list]:not([hidden])', this.root);
      if (sortOpen) { e.stopPropagation(); this.closeSort(true); }
      return;
    }
    if (t.matches('[data-gb-sort-button]') && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
      e.preventDefault(); this.openSort(t, $('[data-gb-sort-list]', t.parentNode));
      return;
    }
    if (t.matches('[data-gb-sort-list]')) this.sortKeys(e, t);
  };

  /* ---------- Groups / show more / value search ---------- */
  Facets.prototype.setGroup = function (group, open) {
    if (!group) return;
    var btn = $('[data-gb-facet-toggle]', group), panel = btn && document.getElementById(btn.getAttribute('aria-controls'));
    if (!btn || !panel) return;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
    group.classList.toggle('is-open', open);
    this.openState[group.getAttribute('data-gb-facet')] = open;
  };
  Facets.prototype.closeDropdowns = function (except) {
    var self = this;
    $$('[data-gb-facet].is-open', this.root).forEach(function (g) { if (g !== except) self.setGroup(g, false); });
  };
  Facets.prototype.setMore = function (group, expanded) {
    var btn = $('[data-gb-facet-more]', group); if (!btn) return;
    $$('.gb-facet__item.is-extra', group).forEach(function (li) { li.hidden = !expanded; });
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    var label = $('[data-gb-facet-more-label]', btn);
    if (label) label.textContent = btn.getAttribute(expanded ? 'data-label-less' : 'data-label-more');
    btn.classList.toggle('is-expanded', expanded);
  };
  Facets.prototype.searchValues = function (input) {
    var group = input.closest('[data-gb-facet]'), q = input.value.trim().toLowerCase();
    var more = $('[data-gb-facet-more]', group);
    if (!q) {
      $$('.gb-facet__item', group).forEach(function (li) { li.classList.remove('is-nomatch'); });
      this.setMore(group, !!this.moreState[group.getAttribute('data-gb-facet')]);
      if (more) more.hidden = false;
      return;
    }
    $$('.gb-facet__item', group).forEach(function (li) {
      var match = (li.getAttribute('data-gb-facet-value') || '').indexOf(q) > -1;
      li.hidden = !match; li.classList.toggle('is-nomatch', !match);
    });
    if (more) more.hidden = true;
  };

  /* Remember open groups + show-more before re-rendering */
  Facets.prototype.captureStates = function (initial) {
    var self = this;
    $$('[data-gb-facet]', this.root).forEach(function (g) {
      var key = g.getAttribute('data-gb-facet');
      var btn = $('[data-gb-facet-toggle]', g);
      if (initial) { self.openState[key] = btn && btn.getAttribute('aria-expanded') === 'true'; }
    });
  };
  Facets.prototype.restoreStates = function () {
    var self = this;
    $$('[data-gb-facet]', this.root).forEach(function (g) {
      var key = g.getAttribute('data-gb-facet');
      if (Object.prototype.hasOwnProperty.call(self.openState, key)) {
        var wantOpen = self.openState[key];
        self.setGroup(g, wantOpen);
      }
      if (self.moreState[key]) self.setMore(g, true);
    });
  };

  /* ---------- Sort listbox ---------- */
  Facets.prototype.openSort = function (btn, list) {
    if (!list) return;
    list.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    var sel = $('[aria-selected="true"]', list) || $('[role="option"]', list);
    this.activateOption(list, sel);
    list.focus({ preventScroll: true });
  };
  Facets.prototype.closeSort = function (focusBtn) {
    $$('[data-gb-sort-list]', this.root).forEach(function (list) {
      if (list.hidden) return;
      list.hidden = true;
      var btn = $('[data-gb-sort-button]', list.parentNode);
      if (btn) { btn.setAttribute('aria-expanded', 'false'); if (focusBtn) btn.focus(); }
    });
  };
  Facets.prototype.activateOption = function (list, opt) {
    if (!opt) return;
    $$('[role="option"]', list).forEach(function (o) { o.classList.toggle('is-active', o === opt); });
    list.setAttribute('aria-activedescendant', opt.id);
    if (opt.scrollIntoView) opt.scrollIntoView({ block: 'nearest' });
  };
  Facets.prototype.sortKeys = function (e, list) {
    var opts = $$('[role="option"]', list), cur = $('.is-active', list), i = Math.max(0, opts.indexOf(cur));
    switch (e.key) {
      case 'ArrowDown': e.preventDefault(); this.activateOption(list, opts[Math.min(opts.length - 1, i + 1)]); break;
      case 'ArrowUp': e.preventDefault(); this.activateOption(list, opts[Math.max(0, i - 1)]); break;
      case 'Home': e.preventDefault(); this.activateOption(list, opts[0]); break;
      case 'End': e.preventDefault(); this.activateOption(list, opts[opts.length - 1]); break;
      case 'Enter': case ' ': e.preventDefault(); if (cur) this.chooseSort(cur); break;
      case 'Tab': this.closeSort(); break;
    }
  };
  Facets.prototype.chooseSort = function (opt) {
    var list = opt.closest('[data-gb-sort-list]'), value = opt.getAttribute('data-value');
    $$('[role="option"]', list).forEach(function (o) { o.setAttribute('aria-selected', o === opt ? 'true' : 'false'); });
    list.setAttribute('data-value', value);
    var current = $('.gb-sort__current', list.parentNode); if (current) current.textContent = opt.textContent.trim();
    $$('[data-gb-sort-input]', this.root).forEach(function (i) { i.value = value; });
    this.closeSort(true);
    this.submit();
  };

  /* ---------- Price range ---------- */
  Facets.prototype.bindPrice = function () {
    $$('[data-gb-price]', this.root).forEach(function (wrap) { wrap.__gbMax = parseFloat(wrap.getAttribute('data-max')) || 0; });
  };
  Facets.prototype.paintPrice = function (wrap, min, max) {
    var top = parseFloat(wrap.getAttribute('data-max')) || 1;
    wrap.style.setProperty('--gb-min', (min / top * 100) + '%');
    wrap.style.setProperty('--gb-max', (max / top * 100) + '%');
    var lmin = $('[data-gb-price-label="min"]', wrap), lmax = $('[data-gb-price-label="max"]', wrap);
    if (lmin) lmin.textContent = money(Math.round(min * 100));
    if (lmax) lmax.textContent = money(Math.round(max * 100));
  };
  Facets.prototype.syncPriceFromRange = function (range) {
    var wrap = range.closest('[data-gb-price]');
    var rMin = $('[data-gb-price-range="min"]', wrap), rMax = $('[data-gb-price-range="max"]', wrap);
    var iMin = $('[data-gb-price-input="min"]', wrap), iMax = $('[data-gb-price-input="max"]', wrap);
    var top = parseFloat(wrap.getAttribute('data-max')) || 0;
    var min = parseFloat(rMin.value), max = parseFloat(rMax.value);
    if (min > max) { if (range === rMin) { min = max; rMin.value = min; } else { max = min; rMax.value = max; } }
    rMin.classList.toggle('is-top', range === rMin && min >= top * 0.9);
    iMin.value = min > 0 ? min : '';
    iMax.value = max < top ? max : '';
    this.paintPrice(wrap, min, max);
  };
  Facets.prototype.syncPriceFromInput = function (input) {
    var wrap = input.closest('[data-gb-price]');
    var rMin = $('[data-gb-price-range="min"]', wrap), rMax = $('[data-gb-price-range="max"]', wrap);
    var iMin = $('[data-gb-price-input="min"]', wrap), iMax = $('[data-gb-price-input="max"]', wrap);
    var top = parseFloat(wrap.getAttribute('data-max')) || 0;
    var min = parseFloat(String(iMin.value).replace(',', '.')), max = parseFloat(String(iMax.value).replace(',', '.'));
    if (isNaN(min) || min < 0) min = 0;
    if (isNaN(max) || max > top) max = top;
    if (min > top) min = top;
    if (max < min && input === iMax && iMax.value !== '') max = min;
    rMin.value = min; rMax.value = max;
    this.paintPrice(wrap, min, max);
  };

  /* ---------- Params ---------- */
  Facets.prototype.buildParams = function () {
    var form = $('[data-gb-facets-form]', this.root);
    var params = new URLSearchParams();
    if (form) {
      var fd = new FormData(form);
      fd.forEach(function (v, k) { if (typeof v === 'string' && v !== '') params.append(k, v); });
      $$('[data-gb-price]', form).forEach(function (wrap) {
        var top = parseFloat(wrap.getAttribute('data-max')) || 0;
        var iMin = $('[data-gb-price-input="min"]', wrap), iMax = $('[data-gb-price-input="max"]', wrap);
        if (iMin && iMin.name && (parseFloat(iMin.value) || 0) <= 0) params.delete(iMin.name);
        if (iMax && iMax.name && (iMax.value === '' || parseFloat(iMax.value) >= top)) params.delete(iMax.name);
      });
    } else {
      params = cleanParams(window.location.search);
      params.delete('page');
    }
    var sortList = $('[data-gb-sort-list]', this.root);
    if (sortList && sortList.getAttribute('data-value')) params.set('sort_by', sortList.getAttribute('data-value'));
    params.delete('page');
    return params.toString();
  };

  Facets.prototype.submit = function () {
    this.render(this.buildParams(), { push: true, scroll: false, source: 'form' });
  };

  Facets.prototype.navigate = function (url, opts) {
    this.closeSort();
    this.render(paramsFromUrl(url), Object.assign({ push: true }, opts || {}));
  };

  /* ---------- Rendering ---------- */
  Facets.prototype.syncIds = function () {
    var ids = [];
    $$('[data-gb-facets-sync]').forEach(function (el) {
      var id = el.getAttribute('data-gb-facets-sync');
      if (id && ids.indexOf(id) < 0) ids.push(id);
    });
    return ids.slice(0, 4);
  };

  Facets.prototype.render = function (params, opts) {
    opts = opts || {};
    var self = this;
    if (this.controller) this.controller.abort();
    var controller = ('AbortController' in window) ? new AbortController() : null;
    this.controller = controller;

    var ids = [this.sectionId].concat(this.syncIds());
    var url = window.location.pathname + '?' + (params ? params + '&' : '') + 'sections=' + encodeURIComponent(ids.join(','));
    this.lastParams = params;
    this.root.classList.add('is-loading');
    this.root.setAttribute('aria-busy', 'true');

    var request = cache.has(url)
      ? Promise.resolve(cache.get(url))
      : fetch(url, { credentials: 'same-origin', signal: controller ? controller.signal : undefined })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function (json) { cache.set(url, json); return json; });

    request
      .then(function (json) {
        if (controller && controller.signal.aborted) return;
        self.apply(json, ids, opts);
        if (opts.push !== false) {
          var next = window.location.pathname + (params ? '?' + params : '');
          if (next !== window.location.pathname + window.location.search) history.pushState({ gbFacets: true }, '', next);
        }
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        self.root.classList.remove('is-loading');
        window.location.href = window.location.pathname + (params ? '?' + params : '');
      });
  };

  Facets.prototype.apply = function (json, ids, opts) {
    var self = this, root = this.root;
    var html = json[this.sectionId];
    if (!html) throw new Error('Missing section');
    var doc = new DOMParser().parseFromString(html, 'text/html');

    var active = document.activeElement;
    var activeId = active && root.contains(active) ? active.id : null;
    var keepGroup = null;
    if (active && root.contains(active) && active.matches('input[type="number"], input[type="range"], input[type="search"]')) {
      keepGroup = active.closest('[data-gb-facet]');
    }
    var searchValues = {};
    $$('[data-gb-facet-search]', root).forEach(function (i) {
      var g = i.closest('[data-gb-facet]'); if (g && i.value) searchValues[g.getAttribute('data-gb-facet')] = i.value;
    });

    $$('[data-gb-facets-part]', root).forEach(function (el) {
      var key = el.getAttribute('data-gb-facets-part');
      var src = doc.querySelector('[data-gb-facets-part="' + key + '"]');
      if (!src) { el.innerHTML = ''; return; }
      if (key === 'groups' && keepGroup) {
        var keepKey = keepGroup.getAttribute('data-gb-facet');
        el.innerHTML = src.innerHTML;
        var fresh = $('[data-gb-facet="' + (window.CSS && CSS.escape ? CSS.escape(keepKey) : keepKey) + '"]', el);
        if (fresh) {
          var freshBadge = $('.gb-facet__badge', fresh), keptBtn = $('[data-gb-facet-toggle]', keepGroup);
          var oldBadge = $('.gb-facet__badge', keepGroup);
          if (oldBadge) oldBadge.remove();
          if (freshBadge && keptBtn) keptBtn.insertBefore(freshBadge, $('.gb-facet__chev', keptBtn));
          fresh.replaceWith(keepGroup);
        }
        return;
      }
      el.innerHTML = src.innerHTML;
      Array.prototype.slice.call(src.attributes).forEach(function (a) {
        if (a.name === 'style' || a.name === 'hidden' || a.name.indexOf('data-') === 0) el.setAttribute(a.name, a.value);
      });
    });

    ids.slice(1).forEach(function (id) {
      var target = document.getElementById('shopify-section-' + id);
      if (!target || json[id] == null) return;
      var sdoc = new DOMParser().parseFromString(json[id], 'text/html');
      var inner = sdoc.getElementById('shopify-section-' + id);
      target.innerHTML = inner ? inner.innerHTML : sdoc.body.innerHTML;
      if (window.GB) GB.init(target);
    });

    this.restoreStates();
    Object.keys(searchValues).forEach(function (key) {
      var g = $('[data-gb-facet="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]', root);
      var input = g && $('[data-gb-facet-search]', g);
      if (input && input !== active) { input.value = searchValues[key]; self.searchValues(input); }
    });
    if (activeId && !keepGroup) {
      var again = document.getElementById(activeId);
      if (again && again.focus) again.focus({ preventScroll: true });
    }

    this.applyDensity();
    this.syncMode();
    root.classList.remove('is-loading');
    root.removeAttribute('aria-busy');
    if (window.GB) GB.init(root);
    this.observeInfinite();
    if (opts.scroll) this.scrollToGrid(true);
    else if (this.scrollToTop && opts.source !== 'history' && !this.isDrawer()) this.scrollToGrid(false);
    document.dispatchEvent(new CustomEvent('gb:facets:updated', { detail: { sectionId: this.sectionId, root: root } }));
  };

  Facets.prototype.scrollToGrid = function (force) {
    var target = $('[data-gb-facets-results]', this.root) || this.root;
    var offset = (parseFloat(getComputedStyle(this.root).getPropertyValue('--gb-sticky-top')) || 0) + this.toolbarHeight() + 12;
    var top = target.getBoundingClientRect().top;
    if (!force && top >= offset - 1) return;
    var y = window.pageYOffset + top - offset;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
  };
  Facets.prototype.toolbarHeight = function () {
    var tb = $('.gb-toolbar--sticky .gb-toolbar__bar', this.root);
    return tb ? tb.offsetHeight : 0;
  };

  /* ---------- Load more / infinite ---------- */
  Facets.prototype.loadMore = function (link) {
    if (this.loading || !link) return;
    var self = this, root = this.root;
    this.loading = true;
    link.classList.add('is-loading');
    root.classList.add('is-appending');
    var url = new URL(link.getAttribute('href'), window.location.origin);
    var params = cleanParams(url.search).toString();
    var fetchUrl = window.location.pathname + '?' + (params ? params + '&' : '') + 'section_id=' + encodeURIComponent(this.sectionId);
    fetch(fetchUrl, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var appended = [];
        $$('[data-gb-facets-append]', root).forEach(function (container) {
          var key = container.getAttribute('data-gb-facets-append');
          var src = doc.querySelector('[data-gb-facets-append="' + key + '"]');
          if (!src) return;
          Array.prototype.slice.call(src.children).forEach(function (child) {
            if (child.classList.contains('gb-promo')) return;
            container.appendChild(child); appended.push(child);
          });
          if (container.children.length) {
            container.classList.remove('is-empty');
            var group = container.closest('.is-empty'); if (group) group.classList.remove('is-empty');
          }
        });
        var pag = $('[data-gb-facets-part="pagination"]', root), pagSrc = doc.querySelector('[data-gb-facets-part="pagination"]');
        if (pag && pagSrc) pag.innerHTML = pagSrc.innerHTML;
        self.loading = false;
        root.classList.remove('is-appending');
        if (window.GB) GB.init(root);
        var first = appended[0] && appended[0].querySelector('a[href]');
        if (first && link === document.activeElement) first.focus({ preventScroll: true });
        self.observeInfinite();
        document.dispatchEvent(new CustomEvent('gb:facets:appended', { detail: { sectionId: self.sectionId, items: appended } }));
      })
      .catch(function () { window.location.href = link.href; });
  };
  Facets.prototype.observeInfinite = function () {
    var self = this;
    if (this.io) this.io.disconnect();
    var trigger = $('[data-gb-infinite]', this.root);
    if (!trigger || !('IntersectionObserver' in window)) return;
    this.io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) self.loadMore(en.target); });
    }, { rootMargin: '0px 0px 600px 0px' });
    this.io.observe(trigger);
  };

  /* ---------- Density ---------- */
  Facets.prototype.applyDensity = function () {
    var root = this.root;
    if (root.getAttribute('data-view-toggle') === 'true') {
      var view = store('gb:grid-view') === 'list' ? 'list' : 'grid';
      root.setAttribute('data-view', view);
      $$('[data-gb-view]', root).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-gb-view') === view ? 'true' : 'false'); });
    }
    if (root.getAttribute('data-density') !== 'true') return;
    var d = store('gb:grid-d'), m = store('gb:grid-m');
    var style = root.style;
    if (d) { style.setProperty('--gb-cols-d', d); style.setProperty('--gb-cols-t', Math.min(d, 3)); }
    if (m) { style.setProperty('--gb-cols-m', m); root.setAttribute('data-cols-m', m); }
    var curD = String(d || parseInt(style.getPropertyValue('--gb-cols-d'), 10));
    var curM = String(m || parseInt(style.getPropertyValue('--gb-cols-m'), 10));
    $$('[data-gb-density]', root).forEach(function (b) {
      var cur = b.getAttribute('data-gb-density') === 'd' ? curD : curM;
      b.setAttribute('aria-pressed', b.getAttribute('data-cols') === cur ? 'true' : 'false');
    });
  };

  /* ---------- Sticky toolbar offset under a sticky header ---------- */
  Facets.prototype.initSticky = function () {
    var self = this, root = this.root;
    var toolbar = $('.gb-toolbar--sticky', root);
    if (!toolbar) return;
    var last = -1, ticking = false;
    var headerEls = function () {
      return $$('.shopify-section-group-header-group, .section-header, [data-gb-sticky-header]').filter(function (el) {
        var pos = getComputedStyle(el).position; return pos === 'sticky' || pos === 'fixed';
      });
    };
    var update = function () {
      ticking = false;
      var bottom = 0;
      headerEls().forEach(function (el) { var r = el.getBoundingClientRect(); if (r.bottom > bottom && r.top <= 1) bottom = r.bottom; });
      bottom = Math.max(0, Math.round(bottom));
      if (bottom !== last) { root.style.setProperty('--gb-sticky-top', bottom + 'px'); last = bottom; }
      var bar = $('.gb-toolbar__bar', root);
      if (bar) toolbar.classList.toggle('is-stuck', toolbar.getBoundingClientRect().top <= bottom + 1 && window.pageYOffset > 0);
    };
    var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
    self.destroySticky = function () { window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onScroll); };
  };

  Facets.prototype.destroy = function () {
    if (DESKTOP.removeEventListener) DESKTOP.removeEventListener('change', this.onModeChange); else DESKTOP.removeListener(this.onModeChange);
    document.removeEventListener('click', this.onDocClick);
    if (this.io) this.io.disconnect();
    if (this.destroySticky) this.destroySticky();
    if (this.onAlign) { window.removeEventListener('resize', this.onAlign); document.removeEventListener('gb:facets:updated', this.onAlign); document.documentElement.classList.remove('gb-sidebar-aligned'); }
    if (this.panel && this.panel.classList.contains('is-open') && window.GB) GB.closeDrawer(this.panel);
  };

  /* ---------- Boot ---------- */
  function primary() { return instances[0] || null; }
  function boot(scope) {
    $$('[data-gb-facets]', scope).forEach(function (root) {
      if (root.__gbFacets) return;
      root.__gbFacets = new Facets(root);
      instances.push(root.__gbFacets);
    });
  }

  // Links inside the grid section OR any synced section (e.g. gb-quick-filter pills)
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-gb-facets-link]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    var holder = a.closest('[data-gb-facets]');
    var inst = holder ? holder.__gbFacets : primary();
    if (!inst) return;
    e.preventDefault();
    inst.navigate(a.href, { scroll: a.hasAttribute('data-gb-scroll'), source: a.hasAttribute('data-gb-scroll') ? 'page' : 'link' });
  });

  document.addEventListener('gb:facets:update', function (e) {
    var inst = primary(); if (!inst || !e.detail) return;
    if (e.detail.url) inst.navigate(e.detail.url, { scroll: !!e.detail.scroll, source: 'event' });
    else if (typeof e.detail.params === 'string') inst.render(e.detail.params, { push: true, source: 'event' });
  });

  window.addEventListener('popstate', function () {
    var inst = primary(); if (!inst) return;
    var params = cleanParams(window.location.search).toString();
    if (params === (inst.lastParams == null ? cleanParams(inst.initialSearch).toString() : inst.lastParams)) return;
    inst.render(params, { push: false, source: 'history' });
  });

  document.addEventListener('shopify:section:load', function (e) {
    instances = instances.filter(function (i) { if (!document.body.contains(i.root)) { i.destroy(); return false; } return true; });
    boot(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    instances = instances.filter(function (i) { if (e.target.contains(i.root)) { i.destroy(); return false; } return true; });
  });

  window.GBFacets = { instances: function () { return instances.slice(); }, boot: boot };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
})();
